export default __webpack_public_path__ + "static/Kira Kutcher - Age 11 School Dance Performance-626bdb4a77c1a1abb0ed2e55ad6f6b11.png";